export default __webpack_public_path__ + "static/media/sliderRes.11770682.png";